import {
  AnyAction,
  applyMiddleware,
  combineReducers,
  createStore,
  compose,
} from "redux"
import {
  routerMiddleware,
  routerReducer,
  RouterState,
} from "react-router-redux"
import { createHashHistory } from "history"
import thunk from "redux-thunk"
import SymbolDetail, {
  ReduxSymbolDetailStateType,
} from "redux/ducks/SymbolDetail"
import User, { UserType } from "redux/ducks/user"
import Cart from "redux/ducks/Chart"
import IndicatorChart from "redux/ducks/IndicatorChart"
import Push from "redux/ducks/Push"
import Calender from "redux/ducks/Calender"
import Toast from "redux/ducks/Toast"
import Setting from "redux/ducks/Setting"
import PageLoad from "redux/ducks/PageLoad"
import SessionTimeOut from "redux/ducks/SessionTimeOut"
import AutoLoadingFlag from "redux/ducks/AutoLoadingFlag"
import RegisterSymbol, {
  RegisterSymbolStateType,
} from "redux/ducks/RegisterSymbol"

type ReducersState = {
  routing: RouterState
  symbolDetail: ReduxSymbolDetailStateType
  registerSymbol: RegisterSymbolStateType
  user: UserType
}

const rootReducer = (state: any, action: AnyAction) => {
  return appReducer(state, action)
}

const appReducer = combineReducers({
  routing: routerReducer,
  symbolDetail: SymbolDetail,
  registerSymbol: RegisterSymbol,
  chart: Cart,
  indicatorChart: IndicatorChart,
  push: Push,
  user: User,
  calender: Calender,
  toast: Toast,
  PageLoad: PageLoad,
  Setting: Setting,
  SessionTimeOut: SessionTimeOut,
  AutoLoadingFlag: AutoLoadingFlag,
})

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export const history = createHashHistory()
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk, routerMiddleware(history)))
)

export default store
